import { createRouter } from '@tanstack/react-router';
import { Route as authorizeRoute } from './routes/authorize.tsx';
import { Route as billingRoute } from './routes/billing.tsx';
import { Route as chatRoute } from './routes/chat.tsx';
import { Route as chatsRoute } from './routes/chats.tsx';
import { Route as connectionsRoute } from './routes/connections.tsx';
import { Route as forgotPasswordRoute } from './routes/forgot-password.tsx';
import { Route as indexRoute } from './routes/index.tsx';
import { Route as invitationRoute } from './routes/invitation.tsx';
import { Route as newSiteRoute } from './routes/new.tsx';
import { Route as resetPasswordRoute } from './routes/reset-password.tsx';
import { Route as rootRoute } from './routes/root.tsx';
import { Route as signInRoute } from './routes/sign-in.tsx';
import { Route as signUpRoute } from './routes/sign-up.tsx';
import { Route as signedInRoute } from './routes/signed-in.tsx';
import { Route as siteActivityRoute } from './routes/site-activity.tsx';
import { Route as siteAssetRoute } from './routes/site-asset.tsx';
import { Route as siteAssetsRoute } from './routes/site-assets.tsx';
import { Route as siteAssistantInboxRoute } from './routes/site-assistant-inbox.tsx';
import { Route as siteAssistantRoute } from './routes/site-assistant.tsx';
import { Route as siteBlogAutomationRoute } from './routes/site-blog-automation.tsx';
import { Route as siteChecksRoute } from './routes/site-checks.tsx';
import { Route as siteDomainRoute } from './routes/site-domain.tsx';
import { Route as siteFormEntriesRoute } from './routes/site-form-entries.tsx';
import { Route as siteFormRoute } from './routes/site-form.tsx';
import { Route as siteFormsRoute } from './routes/site-forms.tsx';
import { Route as siteHeaderFooterRoute } from './routes/site-header-footer.tsx';
import { Route as siteHistoryRoute } from './routes/site-history.tsx';
import { Route as sitePageRoute } from './routes/site-page.tsx';
import { Route as sitePagesRoute } from './routes/site-pages.tsx';
import { Route as sitePostRoute } from './routes/site-post.tsx';
import { Route as sitePostsRoute } from './routes/site-posts.tsx';
import { Route as sitePreviewRoute } from './routes/site-preview.tsx';
import { Route as siteRedirectsRoute } from './routes/site-redirects.tsx';
import { Route as siteReviewsRoute } from './routes/site-reviews.tsx';
import { Route as siteSettingsRoute } from './routes/site-settings.tsx';
import { Route as siteSharingRoute } from './routes/site-sharing.tsx';
import { Route as siteRoute } from './routes/site.tsx';
import { Route as transferRoute } from './routes/transfer.tsx';
export const router = createRouter({
  routeTree: rootRoute.addChildren([
    signInRoute,
    signUpRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    signedInRoute.addChildren([
      indexRoute,
      newSiteRoute,
      chatsRoute,
      chatRoute,
      authorizeRoute,
      connectionsRoute,
      transferRoute,
      invitationRoute,
      billingRoute,
      siteRoute.addChildren([
        sitePreviewRoute,
        sitePagesRoute,
        sitePageRoute,
        sitePostsRoute,
        siteBlogAutomationRoute,
        sitePostRoute,
        siteFormsRoute,
        siteFormRoute,
        siteAssetsRoute,
        siteAssetRoute,
        siteHeaderFooterRoute,
        siteAssistantRoute,
        siteAssistantInboxRoute,
        siteSettingsRoute,
        siteDomainRoute,
        siteRedirectsRoute,
        siteFormEntriesRoute,
        siteReviewsRoute,
        siteActivityRoute,
        siteChecksRoute,
        siteHistoryRoute,
        siteSharingRoute,
      ]),
    ]),
  ]),
  defaultPreload: 'intent',
});
router.subscribe('onResolved', ({ toLocation }) => {
  const path = toLocation.pathname.replace(/\/$/, '');
  document.title =
    path === '/sign-in'
      ? 'Wirechunk App — Sign in'
      : path === '/sign-up'
        ? 'Wirechunk App — Sign up'
        : 'Wirechunk';
});
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
